class Wysiwyg extends DrupalBehavior {

    onContent(context) {
        const allVideos = context.querySelectorAll('.wysiwyg iframe[src^="https://www.youtube.com"]');
        if (allVideos) {
            allVideos.forEach((video) => {
                video.removeAttribute('width');
                video.removeAttribute('height');

                let videoContainer = document.createElement('div');
                videoContainer.classList.add('embed-container');

                video.parentNode.insertBefore(videoContainer, video);

                videoContainer.appendChild(video);
            });
        }
    }
}

DrupalBehavior.register('summit_theme', 'wysiwyg', Wysiwyg);
      